export default "__VITE_PUBLIC_ASSET__4cdd50b2__"